module.exports = __webpack_public_path__ + "assets/images/document-icon.e5d9264a825c665d364974b6fec56ec1.svg";